export interface IQuotable {
  shouldQuote: boolean;
  supportedQuotable: boolean;
  isQuoted: boolean;
}

export function instanceOfIQuotable(instance: any): instance is IQuotable {
  return instance
    && (instance.shouldQuote !== undefined)
    && (instance.supportedQuotable !== undefined)
    && (instance.isQuoted !== undefined);
}
